<div class="sl-input-container">
  <div class="sl-input-label-counter-container">
    <div class="sl-input-label-container">
      <span>
        <sl-typography
          [text]="label"
          variant="label"
          [color]="getTagColor()"
        ></sl-typography>
      </span>
      @if(required){
      <sl-typography
        text="*"
        variant="label"
        [color]="
          mode === 'standard' ? 'var(--color-red-60)' : 'var(--color-red-10)'
        "
      ></sl-typography>
      }
    </div>
    @if(variant === 'textarea'){
    <sl-typography
      [text]="charCount + '/' + maxLength"
      variant="label"
      [color]="getTagColor()"
    ></sl-typography>
    }
  </div>
  <div
    class="sl-input-textbox-container"
    [ngClass]="{
      disabled: disabled
    }"
  >
    <div class="sl-input-textbox-icon">
      @if(variant === 'text'){
      <input
        [id]="id + '-input'"
        [attr.aria-label]="ariaLabel"
        class="sl-input-textbox"
        [type]="type === 'password' && !showPassword ? 'password' : ''"
        [placeholder]="placeholder"
        [ngClass]="{
          error: control && control.invalid && control.touched,
          'standard-mode': mode === 'standard',
          'brand-mode': mode === 'brand',
          'dark-mode': mode === 'dark'
        }"
        [formControl]="control"
        autocomplete="on"
        [attr.aria-required]="required ? 'true' : 'false'"
        [readOnly]="isReadOnly"
        [tabIndex]="isReadOnly ? -1 : 0"
        [ngStyle]="{ cursor: isClickable ? 'pointer' : 'auto' }"
      />
      }@else if(variant === 'textarea'){
      <textarea
        class="sl-input-textbox"
        (input)="onChangeTextArea($event)"
        [placeholder]="placeholder ?? ''"
        [ngStyle]="{ height: '150px', resize: 'vertical' }"
        [ngClass]="{
          error: control && control.invalid && control.touched,
          'standard-mode': mode === 'standard',
          'dark-mode': mode === 'dark',
          'brand-mode': mode === 'brand'
        }"
        [formControl]="control"
        [attr.aria-required]="required ? 'true' : 'false'"
        [readOnly]="isReadOnly"
        [tabIndex]="isReadOnly ? -1 : 0"
      ></textarea>
      } @if(variant === 'text' && type === 'password'){
      <div class="sl-input-visibility-button">
        <sl-button
          [id]="id ? id : 'input-button'"
          type="icon-only"
          variant="tertiary"
          (clickEvent)="onClickShowPassword()"
          [iconName]="showPassword ? 'visibility' : 'visibility_off'"
          [ariaLabel]="showPassword ? 'shown password' : 'hidden password'"
          [disabled]="control.disabled"
          color="input"
          size="small"
        ></sl-button>
      </div>
      } @if(icon){
      <div class="sl-input-visibility-button">
        <sl-button
          [id]="id ? id : 'input-button'"
          type="icon-only"
          variant="tertiary"
          (keyup)="onKeyUpShowPassword($event)"
          (clickEvent)="handleIconClick()"
          [iconName]="icon"
          [ariaLabel]="icon"
          [disabled]="disabled"
          color="input"
          size="small"
          autocomplete="off"
          #outerButton
        ></sl-button>
      </div>
      }
    </div>
    @if(assistiveText || (control && control.invalid && control.touched)){
    <div class="sl-input-assistive-text-container">
      <span
        class="material-symbols-outlined"
        [ngClass]="{
          error: control.invalid && control.touched,
          'standard-mode': mode === 'standard',
          'dark-brand-mode': mode === 'dark' || mode === 'brand'
        }"
      >
        {{ control.invalid && control.touched ? 'error' : 'info' }}
      </span>
      <p
        class="sl-input-assistive-text"
        [ngClass]="{
          error: control.invalid && control.touched,
          'standard-mode': mode === 'standard',
          'dark-brand-mode': mode === 'dark' || mode === 'brand'
        }"
      >
        {{
          control.invalid && control.touched ? getErrorMessage() : assistiveText
        }}
      </p>
    </div>
    }
  </div>
</div>
